export default __webpack_public_path__ + "static/V-ALI1_Kevyt_alivalotus2-a6561f366dfd46ca8636efe0d9a76581.jpg";